globalThis.Pagination = class Pagination {
  constructor() {
    this.abort = new AbortController();
    this.div = document.createElement("div");
    this.div.classList.add("pagination");
    this.pages = 1;
    this.active = 0;
    this.buttons = [];
    this.setPages(this.pages);
  }

  remove() {
    this.abort.abort();
    this.div.remove();
  }

  setPages(pages) {
    this.pages = pages;
    this.active = Math.max(Math.min(this.active, this.pages - 1), 0);
    this.removeButtons();
    this.createButtons();
    this.renderActive();
  }

  setActive(detail) {
    this.active = detail;
    this.renderActive();
    this.div.dispatchEvent(new CustomEvent("active", { detail }));
  }

  removeButtons() {
    this.div.innerHTML = "";
    this.buttons = [];
  }

  createButtons() {
    if (this.pages === 1) return;
    for (const i of this.getShowPages()) {
      const button = document.createElement("button");
      if (i == null) button.classList.add("null");
      else button.innerText = i + 1;
      button.addEventListener("click", () => this.setActive(i), this.abort);
      button._index = i;
      this.buttons.push(button);
      this.div.append(button);
    }
  }

  getShowPages() {
    const indexes = [];
    const add = (i) => indexes.includes(i) || indexes.push(i);
    if (this.pages <= 9) for (let i = 0; i < this.pages; i++) add(i);
    else {
      add(0);
      add(1);
      if (this.active > 3) indexes.push(null);
      if (this.active) add(this.active - 1);
      add(this.active);
      if (this.active < this.pages - 1) add(this.active + 1);
      if (this.active < this.pages - 4) indexes.push(null);
      add(this.pages - 2);
      add(this.pages - 1);
    }
    return indexes;
  }

  renderActive() {
    for (const button of this.buttons) {
      if (this.active === button._index) button.classList.add("active");
      else button.classList.remove("active");
    }
  }
};
